import React, { Component } from 'react';
import { Button, Loader, Icon } from 'semantic-ui-react';
import "./sweetalert.scss";


class SweetAlerts extends Component {
   constructor(props) {
      super(props);
      this.state = {
         errors: [],
         showAlert: true
      }
   }

   handleClose = () => {
      this.setState({ showAlert: false })
      this.props.closeAlert(true)
   }
   
   render_message = () => {
      const { html, message } = this.props
      console.log('html ', html )
      if( html!= undefined ){
         if( html == true ){
            return (
               <>
                  <p dangerouslySetInnerHTML={{ __html: message }}>{}</p>
               </>
            )
         }
      }
      
      return (
         <>
            <p>{message}</p>
         </>
      )
   }

   render() {
      const { showAlert } = this.state;
      const { type, title, message } = this.props
      return (
         <span>

            <div className='alert-mask'>
               <div className={`alert-card ${showAlert ? "animate" : ""}`}>
                  {this.props.showCloseButton !== false && (
                     <button className='alert-close-btn' onClick={this.handleClose}>
                        <Icon name='close' />
                     </button>
                  )}
                  <div className='alert-icon'>
                     {type == 'E' && (<div className="error-mark">
                        <div className="check-icon">
                           <span className="icon-line line-tip"></span>
                           <span className="icon-line line-long"></span>
                           <div className="icon-circle"></div>
                           <div className="icon-fix"></div>
                        </div>
                     </div>)}
                     {type == 'S' && (
                        <div className="success-checkmark">
                           <div className="check-icon">
                              <span className="icon-line line-tip"></span>
                              <span className="icon-line line-long"></span>
                              <div className="icon-circle"></div>
                              <div className="icon-fix"></div>
                           </div>
                        </div>
                     )}
                  </div>
                  <h1>{title}</h1>
                  {this.render_message()}
                  <div className='action'>
                     {!this.props.showAction && (
                        <>
                           {this.props.button_text != undefined && this.props.button_text != '' ? (
                              <Button type='button' onClick={this.handleClose} style={this.props.buttonStyle} className={this.props.buttonClassName}>{this.props.button_text}</Button>

                           ) : (
                              <Button type='button' onClick={this.handleClose} style={this.props.buttonStyle} className={this.props.buttonClassName}>Close</Button>

                           )}
                        </>
                     )}
                     {
                        this.props.showAction && (
                           <Button type='button' className={this.props.actionButtonClassName || ''} style={this.props.actionButtonStyle} primary onClick={()=> this.props.buttonAction()}>{this.props.ActionText}</Button>
                        )}
                  </div>
               </div>
            </div>

         </span>
      )
   }
}

export default SweetAlerts;